export default __webpack_public_path__ + "static/media/342.e22f0c9e.png";